import styles from "./approval.module.css";
import { guestPassDisplay } from "./guestPass";
import { getApproval, isVehicleRow } from "./vehicleRows";

// Pass badge colors per guestPassDisplay tone
const PASS_TONES = {
  active: { color: "#047857", background: "#D1FAE5" },
  awaiting: { color: "#B45309", background: "#FEF3C7" },
  expired: { color: "#B91C1C", background: "#FEE2E2" },
  none: { color: "#6B7280", background: "#F3F4F6" },
};

// PARKING PASS column: guests show their pass, tenants need none, requests get one only after approval
const PassCell = ({ row, showSub = true }) => {
  const state = getApproval(row).state;
  let badge = null;
  let sub = "";

  if (!isVehicleRow(row) && state === "pending") sub = "After approval";
  else if (state === "rejected") sub = "No access";
  else if (row?.is_guest === 1) {
    const pass = row.pass || guestPassDisplay(row.guest_pass);
    const tone = PASS_TONES[pass.tone] || PASS_TONES.none;
    badge = <span className={styles.PassBadge} style={{ color: tone.color, background: tone.background }}>{pass.badge}</span>;
    sub = pass.subLabel;
  } else sub = "Not needed";

  return (<div className={styles.PassCell}>
    {badge || <span className={styles.PassDash}>—</span>}
    {showSub && sub && <span className={styles.Sub}>{sub}</span>}
  </div>);
};

export default PassCell;
